<template>
  <div class="robot-assistant-content">
    <template v-for="(segment, idx) in segments">
      <div
        v-if="segment.type === 'text'"
        :key="'text-' + idx"
        class="assistant-text rich-text ai-assistant"
        v-html="renderText(segment.value)"
      ></div>
      <AiAskResourceBlock
        v-else
        :key="'res-' + segment.value.resourceId + '-' + idx"
        :resource-id="segment.value.resourceId"
        :name="segment.value.name"
        :media-id="segment.value.mediaId"
        :resource-type="segment.value.resourceType"
        :goods-id="goodsId"
      />
    </template>
  </div>
</template>

<script>
import AiAskResourceBlock from "./AiAskResourceBlock.vue";
import {
  parseAiAskResourceSegments,
  renderAssistantMarkdown,
} from "@/utils/ai-ask-resource-parse";
import { isRobotSupportedResourceType } from "@/utils/subject-resource-type";

export default {
  name: "RobotAssistantContent",
  components: { AiAskResourceBlock },
  props: {
    text: {
      type: String,
      default: "",
    },
    goodsId: {
      type: String,
      default: "",
    },
  },
  computed: {
    segments() {
      return parseAiAskResourceSegments(this.text).filter((segment) => {
        if (segment.type === "text") return Boolean(segment.value && segment.value.trim());
        return isRobotSupportedResourceType(segment.value.resourceType);
      });
    },
  },
  methods: {
    renderText(value) {
      return renderAssistantMarkdown(value);
    },
  },
};
</script>

<style scoped>
.robot-assistant-content {
  word-break: break-word;
}
</style>
